export default "__VITE_ASSET__BsxRcZl1__"